import { render } from "./ComponentView.vue?vue&type=template&id=76879e60&scoped=true"
import script from "./ComponentView.vue?vue&type=script&lang=js"
export * from "./ComponentView.vue?vue&type=script&lang=js"

import "./ComponentView.vue?vue&type=style&index=0&id=76879e60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76879e60"]])

export default __exports__